import React from 'react';
import { LoadingSpinner } from 'pepsico-ds';
// import { FiMaximize } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/utils/constants/routesConstants';

const StatusBar = ({ percentage, count, color }) => (
  <div
    className={`flex items-center justify-center text-white text-[10px] font-[700] px-1`}
    style={{ width: `${percentage}%`, backgroundColor: color }}>
    {count}
  </div>
);

const StatusLegend = ({ color, label }) => (
  <div className='flex items-center gap-1.5'>
    <span
      className='w-3 h-3 rounded-full inline-block'
      style={{ backgroundColor: color }}></span>
    <span className='text-[14px] font-[400]'>{label}</span>
  </div>
);

const OktaStatusChart = ({
  totalStores = 0,
  activeStores = 0,
  lockedOutStores = 0,
  suspendedStores = 0,
  deprovisionedStores = 0,
  inactiveStores = 0,
  onExpand,
  isLoading,
  onClick
}) => {
  const navigate = useNavigate();

  const statuses = [
    { label: 'Active', count: activeStores, color: '#5bb4f0' },
    { label: 'Locked Out', count: lockedOutStores, color: '#c94281' },
    { label: 'Suspended', count: suspendedStores, color: '#b668a8' },
    { label: 'Inactive', count: inactiveStores, color: '#62365a' },
    { label: 'Deprovisioned', count: deprovisionedStores, color: '#4f88bd' }
  ];

  const formatNumber = num =>
    num >= 1000 ? `${Math.round(num / 1000)}k` : num.toString();

  return (
    <div
      className='bg-[#1e1e1e] rounded-lg p-4 py-8 text-white w-full'
      // onClick={() => navigate(ROUTES.ONBOARDING_STATUS_OKTA_ACTIVE)}
      onClick={onClick}
      style={{ cursor: 'pointer' }}>
      <div className='flex justify-between items-center mb-4'>
        <h2 className='m-0 text-md text-[#D0D0D0] font-[700]'>
          Okta Status To Date
        </h2>
        {/* <button 
          className="bg-transparent border border-[#444] rounded text-[#4f88bd] cursor-pointer flex items-center justify-center p-1.5"
          onClick={onExpand}
        >
          <FiMaximize />
        </button> */}
      </div>

      <div className='mb-4 mt-8'>
        <div className='flex h-[40px] w-full overflow-hidden'>
          {isLoading ? (
            <div className='flex items-center justify-center h-full w-full'>
              <LoadingSpinner
                size={{
                  height: '20px',
                  width: '20px'
                }}
              />
            </div>
          ) : (
            statuses.map(({ label, count, color }) => (
              <StatusBar
                key={label}
                percentage={(count / totalStores) * 100}
                count={formatNumber(count)}
                color={color}
              />
            ))
          )}
        </div>
      </div>

      <div className='flex flex-wrap justify-center gap-x-4 gap-y-2 mt-8'>
        {statuses.map(({ label, color }) => (
          <StatusLegend key={label} label={label} color={color} />
        ))}
      </div>
    </div>
  );
};

export default OktaStatusChart;
